import { useTranslation } from 'react-i18next';
import {
  EMAIL_LOG_STATUS_FILTERS,
  type EmailLogStatusFilter as StatusFilterValue,
} from '@/constants/emailLog';
import { cn } from '@/lib/utils';

interface EmailLogStatusFilterProps {
  value: StatusFilterValue;
  onChange: (nextValue: StatusFilterValue) => void;
}

export function EmailLogStatusFilter({ value, onChange }: EmailLogStatusFilterProps) {
  const { t } = useTranslation('emailLog');
  return (
    <div
      role="group"
      aria-label={t('filter.label')}
      className="grid grid-cols-3 sm:inline-flex bg-zoowhite border border-zooborder rounded-xl p-1 self-start"
    >
      {EMAIL_LOG_STATUS_FILTERS.map(function renderOption(option) {
        const isSelected = value === option;
        return (
          <button
            key={option}
            type="button"
            aria-pressed={isSelected}
            onClick={function select() {
              onChange(option);
            }}
            className={cn(
              'px-3 sm:px-4 py-2 rounded-lg text-xs font-bold transition-colors',
              isSelected ? 'bg-zooprimary text-zoowhite' : 'text-zoomuted'
            )}
          >
            {t('filter.' + option)}
          </button>
        );
      })}
    </div>
  );
}
